import React from 'react';
import { type SxProps, type Theme, Typography } from '@mui/material';

export const SectionHeader: React.FC<{
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}> = ({ children, sx }) => {
  const baseSx = {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.5px',
    color: 'text.secondary',
    display: 'block',
  };

  return (
    <Typography variant="overline" sx={sx ? { ...baseSx, ...(sx as object) } : baseSx}>
      {children}
    </Typography>
  );
};
